import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

// 상태정보 - 구성정보
const GwInfo = ({
                  propType = "gateway",
                  propName = "게이트웨이",
                  propInfo
                }) => {
  return (
      <>
        <h6 className={"info-container-title text-center mt-3"}>{propName} 구성 정보</h6>
        <div className={'content-container-body-item'}>
          <Form
              className={'equipment-form py-3'}
              id={'equipmentForm'}
          >
            <Row className={"justify-content-center"}>
              <Col md={12}>
                <Row>
                  <Col md={12}>
                    <Form.Group as={Row} controlId="formGwId">
                      <Form.Label column md={4} className={'label text-end'}>
                        게이트웨이 ID
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.gtwy_id || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formGwIp1'>
                      <Form.Label column md={4} className={'label text-end'}>
                        GW IP1
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.ip1_addr || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formGwIp2'>
                      <Form.Label column md={4} className={'label text-end'}>
                        GW IP2
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.ip2_addr || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        L2 IP
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.l2_ip_addr || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        시설명
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.fclty_nm || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyCmd'>
                      <Form.Label column md={4} className={'label  text-end'}>
                        시설관할
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.atdrc_nm || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyAddr'>
                      <Form.Label column md={4} className={'label  text-end'}>
                        시설주소
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.locplc_addr || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='form'>
                      <Form.Label column md={4} className={'label text-end'}>
                        위도/경도
                      </Form.Label>
                      <Col md={4} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.la || undefined}
                        />
                      </Col>
                      <Col md={4} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.lo || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formGwMkr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        GW 제조사
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.mkr || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formGwMd'>
                      <Form.Label column md={4} className={'label text-end'}>
                        GW 모델
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.modl || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formGwDate'>
                      <Form.Label column md={4} className={'label text-end'}>
                        설치일자
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.instl_de || undefined}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </>
  );
};

export default GwInfo;
